import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getTrackingNumbers } from "@redotech/redo-fulfillment-group-common/fulfillment-group-tracking";

export const TrackingNumberCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Tracking number",
    cell: (row) => {
      return getTrackingNumbers(row).join(", ");
    },
  };
